import React from 'react';
import { connect } from 'react-redux';
import { ChatAction } from 'redux/actions';
import { ConvertUtcToLocal as DateFormat, checkPermissions } from 'hooks';
import { Link } from 'react-router-dom';
import Avatar from 'components/Avatar';
import noImage from 'assets/img/users/no-image.jpg';
import ReactPlayer from 'react-player';
import ReactAudioPlayer from 'react-audio-player';
import Skeleton from '@mui/material/Skeleton';
import ImageCarousel from 'components/carousel';
import { MdArrowBack } from 'react-icons/md';

const roomSection = { border: '1px solid #dee2e6', borderRadius: 5, float: 'left', width: '30%', height: 450, overflow: 'auto' };
const chatSection = { border: '1px solid #dee2e6', borderRadius: 5, padding: 10, float: 'right', width: '68%', height: 450, overflow: 'auto' };
const roomStyle = { cursor: 'pointer', padding: 5, paddingLeft: 10, borderBottom: '1px solid #dee2e6' };
const activeRoomStyle = { background: 'rgb(58 172 214)', color: '#fff' };
const textMessage = { padding: 10, margin: 20, width: '50%' };
const currentUserText = { padding: 10, margin: 20, marginLeft: 'auto', width: '50%' };
const messageBox = { background: '#efefef', padding: 10, borderRadius: 5, color: '#444' };
const userMessageBox = { background: '#e8f1f3', padding: 10, borderRadius: 5, color: '#444' };
const backButton = { background: '#10b3e6', padding: 10, color: '#fff', fontSize: 16 };
const Conversatation = (props) => {

    const isFirstRender = React.useRef(true);
    const [activeRoom, setActiveRoom] = React.useState(null);
    const [showBackButton, setShowBackButton] = React.useState(false);

    let [messageData, setMessageData] = React.useState([]);
    let [roomData, setRoomData] = React.useState([]);
    const isClicked = React.useRef(true);



    React.useEffect(() => {
        if (props.rooms && props.rooms.length > 0 && !isMobile(props.breakpoint) && isClicked.current) {
            isClicked.current = false;
            handleClick(props.rooms[0].id);
        }

    }, [props.rooms]);


    React.useEffect(() => {
        if (!isMobile(props.breakpoint)) {
            backToDesktop();
        } else {
            backToRoom();
        }
    }, [props.breakpoint, document.querySelector('.room-section')]);


    React.useEffect(() => {
        if (isFirstRender.current) {
            props.getRooms({ user_id: props.userId});
        }
        isFirstRender.current = false;
    });

    
    const isMobile = (breakpoint) => {
        switch (breakpoint) {
            case 'xs':
            case 'sm':
            case 'md':
                return true;

            case 'lg':
            case 'xl':
            default:
                return false;
        }
    }

    const backToDesktop = () => {
        setShowBackButton(false);
        document.querySelector('.room-section') && document.querySelector('.room-section').classList.remove('hideInMobile');
        document.querySelector('.room-section') && document.querySelector('.room-section').classList.remove('showInMobile');
        document.querySelector('.chat-section') && document.querySelector('.chat-section').classList.remove('showInMobile');
        document.querySelector('.chat-section') && document.querySelector('.chat-section').classList.remove('hideInMobile');
    }

    const backToChat = () => {
        setShowBackButton(true);
        document.querySelector('.room-section') && document.querySelector('.room-section').classList.add('hideInMobile');
        document.querySelector('.room-section') && document.querySelector('.room-section').classList.remove('showInMobile');
        document.querySelector('.chat-section') && document.querySelector('.chat-section').classList.add('showInMobile');
        document.querySelector('.chat-section') && document.querySelector('.chat-section').classList.remove('hideInMobile');
    }
    const backToRoom = (roomId) => {
        setShowBackButton(false);
        document.querySelector('.room-section') && document.querySelector('.room-section').classList.remove('hideInMobile');
        document.querySelector('.room-section') && document.querySelector('.room-section').classList.add('showInMobile');
        document.querySelector('.chat-section') && document.querySelector('.chat-section').classList.remove('showInMobile');
        document.querySelector('.chat-section') && document.querySelector('.chat-section').classList.add('hideInMobile');
    }

    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;

        console.log('chatscrool', props.chatscrool)
        if (bottom && props.messageTotalPage > props.messageNextPage) {
           
            props.getMessages({ user_id: props.userId, room_id: activeRoom, page: props.messageNextPage });
        }
    }

    React.useEffect(() => {
        setMessageData(current => [...current, ...props.messages]);
    }, [props.messages])

    const handleClick = (roomId) => {

        setActiveRoom(roomId);
        setMessageData([]);
        
        props.getMessages({ user_id: props.userId, room_id: roomId, page: 0 })
        if (isMobile(props.breakpoint)) {
            backToChat();
        }
    }



    const handleRoomScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        if (bottom && props.roomTotalPage > props.roomNextPage) {
            props.getRooms({ user_id: props.userId, page: props.roomNextPage });
        }
    }

    React.useEffect(() => {
        setRoomData(current => [...current, ...props.rooms]);
    }, [props.rooms])
    

    return (
        <div>
            {showBackButton && <div style={backButton} onClick={backToRoom}><MdArrowBack /> Back</div>}
            {(roomData && roomData.length > 0) ?
                <div>
                    <div style={roomSection} className={'room-section'} onScroll={handleRoomScroll}>
                        {
                            roomData.map((room,index) => (
                                <div key={index} style={(room.id === activeRoom) ? { ...roomStyle, ...activeRoomStyle } : roomStyle} onClick={() => handleClick(room.id)} >
                                    {(room.name) ? room.name : room.channel}
                                    <div style={{ fontSize: 12, minHeight: 15 }}>{(room.last_message && room.last_message.message) ? `${(room.last_message.message).substr(0, 20)}...` : (room.last_message && room.last_message.type) ? room.last_message.type : ''}</div>
                                </div>)
                            )
                        }
                    </div>
                    <div style={chatSection} className={'chat-section'} onScroll={handleScroll}>

                        {(props.isLoading && messageData.length === 0) ?
                            <div>
                                {[1, 2, 3].map((val, index) =>
                                (<div key={index} style={textMessage}>
                                    <div style={{ color: '#3aacd6', marginBottom: 5, display: 'flex' }}>
                                        <Skeleton animation="wave" variant="rectangular" width={30} height={30} style={{ marginRight: 5, borderRadius: '30%' }} />
                                        <Skeleton variant="rectangular" width={100} height={20} style={{ marginTop: 5, borderRadius: 5 }} />
                                    </div>
                                    <div>
                                        <Skeleton variant="rectangular" width={300} height={40} style={{ borderRadius: 5 }} />
                                    </div>
                                    <div>
                                        <Skeleton variant="rectangular" width={150} height={10} style={{ marginTop: 5, borderRadius: 5 }} />
                                    </div>
                                </div>))
                                }

                            </div>
                            : 
                            <div>{(messageData && messageData.length > 0)
                                ? messageData.map((item,index) => (
                                    <div key={index} className={`chat-messages ${(parseInt(item.sender.id) === parseInt(props.userId)) ? 'current-user-chat' : ''}`} style={(parseInt(item.sender.id) === parseInt(props.userId)) ? currentUserText : textMessage}>
                                        <div style={{ color: '#3aacd6', marginBottom: 5 }}>
                                            <Avatar src={(item.sender.avatar) ? item.sender.avatar : noImage} style={{ width: 30, height: 30, marginRight: 5, borderRadius: '30%' }} circle={false} />
                                            {checkPermissions(props.loginData, 'user_profile') ?
                                                <Link to={`/user-profile/${item.sender.id}`}>
                                                    {item.sender.username}
                                                </Link>
                                                : item.sender.username
                                            }
                                        </div>
                                        <div style={(item.type === 'TEXT' || item.type === '')
                                            ? (parseInt(item.sender.id) !== parseInt(props.userId)) ? messageBox : userMessageBox : {}} >
                                            {(item.type === 'AUDIO') ? <ReactAudioPlayer src={item.media} controls style={{ width: '100%' }} />
                                                : (item.type === 'IMAGE') ? <img alt={'media message'} src={item.media} width={'100%'} />
                                                    : (item.type === 'VIDEO') ? <ReactPlayer url={item.media} width='100%' height='100%' />
                                                        : (item.type === 'POST') ? <div>{(item.message) && <div style={{ marginBottom: 5 }}>{item.message}</div>}{(item.post && item.post.post_meta) && <ImageCarousel items={item.post.post_meta} />}</div>
                                                            : item.message}
                                        </div>
                                        <div style={{ color: '#90777d', fontSize: 12 }}>{DateFormat(item.updated_at, 'ddd d MMM, YYYY HH:mm:ss')}</div>
                                    </div>))
                                    
                                : <div>There is no message</div>
                            }
                            {(props.isLoading) && <div style={textMessage}>
                                    <div style={{ color: '#3aacd6', marginBottom: 5, display: 'flex' }}>
                                        <Skeleton animation="wave" variant="rectangular" width={30} height={30} style={{ marginRight: 5, borderRadius: '30%' }} />
                                        <Skeleton variant="rectangular" width={100} height={20} style={{ marginTop: 5, borderRadius: 5 }} />
                                    </div>
                                    <div>
                                        <Skeleton variant="rectangular" width={300} height={40} style={{ borderRadius: 5 }} />
                                    </div>
                                    <div>
                                        <Skeleton variant="rectangular" width={150} height={10} style={{ marginTop: 5, borderRadius: 5 }} />
                                    </div>
                                </div>}
                            </div>

                        }
                    </div>
                </div>
                : <div>There is no conversatation yet</div>
            }
        </div>
    );
}


const mapStateToProps = (state) => ({
    rooms: (state.chat && state.chat.rooms && state.chat.rooms.chat_rooms) ? state.chat.rooms.chat_rooms : [],
    messages: (state.chat && state.chat.messages && state.chat.messages.messages) ? state.chat.messages.messages : [],
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,

    messageTotalPage: (state.chat && state.chat.messages && state.chat.messages.total_page) ? state.chat.messages.total_page : 1,
    messageNextPage: (state.chat && state.chat.messages && state.chat.messages.nextPage) ? state.chat.messages.nextPage : 0,

    roomTotalPage: (state.chat && state.chat.rooms && state.chat.rooms.chat_rooms) ? state.chat.rooms.total_page : 1,
    roomNextPage: (state.chat && state.chat.rooms && state.chat.rooms.chat_rooms) ? state.chat.rooms.nextPage : 0,

    chatscrool: (state.chat)?state.chat:[]
});
const mapDispatchToProps = (dispatch) => ({
    getRooms: (payload) => dispatch(ChatAction.getChatRooms(payload)),
    getMessages: (payload) => dispatch(ChatAction.getChatMessages(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Conversatation);


